'use strict';
let xfScript = {
    data() {
        return{
            xfForm: {},
            xfShow: false,
            orderData: {},
            deferVisible: false,
            xfDetailShow: false,
            xfBoxList: [],
            BOX_CODE_LIST: [],
            xfValidateRules: {
                TAKE_DATE: [{required: true, message: this.$t('pleaseSelectThePickUpConfirmationTime'), trigger: ['blur','change']}],
            },
            xfDetailList: [],
            xfList: [],
            deferForm: {},
            deferValidateRules: {
                DELAY_QTY: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(this.$t('pleaseFillInTheNumberOfDelayedBoxes'))
                            } else if ((value > (this.deferForm.REAL_QTY - this.deferForm.TERM_QTY)) || value <= 0) {
                                callback(this.$t('extensionBoxIsOver'))
                            } else {
                                callback()
                            }
                        }, trigger: ['blur', 'change'],},
                ],
                DELAY_END_DATE: [{required: true, message: this.$t('pleaseFillInTheExtensionDate'), trigger: ['blur', 'change']}],
            },
            xfFileMap: {},
            takesRecordShow: false,
            xfParamsData: {
                "SYS_TYPE": "20011003",
                "TARGET_CATE": "20021017",
                "TARGET_TYPE": "20071007",
                "TARGET_ID": "",
                "GUID_CODE":""
            }
        }
    },
    computed:{
        takeColumns(){
            let columns = [];
            columns.push({dataIndex: 'BOX_CODE', title: this.$t('container'), scopedSlots: {customRender: 'BOX_CODE'}});
            columns.push({dataIndex: 'SEND_DATE', title: this.$t('TakeBoxTime'), scopedSlots: {customRender: 'SEND_DATE'}});
            columns.push({dataIndex: 'SEND_DRIVER', title: this.$t('driverInfo'), scopedSlots: {customRender: 'SEND_DRIVER'}});
            columns.push({dataIndex: '_id', title: this.$t('operate'),width: '120px', scopedSlots: {customRender: 'operation'}});
            return columns;
        }
    },
    methods: {
/*        xfFinished(data){
            let file = data?.FILE_LIST.map(val =>{
                return val.GUID_CODE
            })
            this.$set(this.xhForm,'GUID_CODES',file.join(','));
            this.$refs.xhForm.validateField('GUID_CODES');
        },*/
        deleteXfItem(index){
            this.xfBoxList.splice(index,1);
        },
        addXfItem(){
            this.xfBoxList.push({
                BOX_CODE: '',
                TAKE_DATE: '',
                "PARENT_FLOW_ID": this.xfForm.FLOW_ID,
                "MEMO": this.xfForm.MEMO,
                "MASTER_ID": this.xfForm.MASTER_ID,
                "SEND_DRIVER": this.xfForm.SEND_DRIVER,
                "SEND_PERSON": this.xfForm.SEND_PERSON,
                "SEND_TRUCK": this.xfForm.SEND_TRUCK,
                "CURRENCY_ID": this.xfForm.CURRENCY_ID,
            })
            /*for (let i = 0;i < data.REAL_QTY - data.PICK_QTY;i++){
               xfBoxList.push({
                   BOX_CODE: '',
                   TAKE_DATE: '',
                   "PARENT_FLOW_ID": data.FLOW_ID,
                   "MEMO": data.MEMO,
                   "MASTER_ID": data.MASTER_ID,
                   "SEND_DRIVER": data.SEND_DRIVER,
                   "SEND_PERSON": data.SEND_PERSON,
                   "SEND_TRUCK": data.SEND_TRUCK,
                   "CURRENCY_ID": data.CURRENCY_ID,
               })
           }*/
        },
        confirmXfBox(data) {
            let xfBoxList = [{
                BOX_CODE: '',
                TAKE_DATE: '',
                "PARENT_FLOW_ID": data.FLOW_ID,
                "MEMO": data.MEMO,
                "MASTER_ID": data.MASTER_ID,
                "SEND_DRIVER": data.SEND_DRIVER,
                "SEND_PERSON": data.SEND_PERSON,
                "SEND_TRUCK": data.SEND_TRUCK,
                "CURRENCY_ID": data.CURRENCY_ID,
            }];
            this.xfForm = data;
            /*for (let i = 0;i < data.REAL_QTY - data.PICK_QTY;i++){
                xfBoxList.push({
                    BOX_CODE: '',
                    TAKE_DATE: '',
                    "PARENT_FLOW_ID": data.FLOW_ID,
                    "MEMO": data.MEMO,
                    "MASTER_ID": data.MASTER_ID,
                    "SEND_DRIVER": data.SEND_DRIVER,
                    "SEND_PERSON": data.SEND_PERSON,
                    "SEND_TRUCK": data.SEND_TRUCK,
                    "CURRENCY_ID": data.CURRENCY_ID,
                })
            }*/
            this.xfBoxList = xfBoxList;
            this.xfShow = true;
        },
        cancelXfModel(){
            this.BOX_CODE_LIST = [];
            this.xfForm = {};
        },
        openDelay(data) {
            this.deferForm = Object.assign({},data);
            this.deferForm.DELAY_QTY = 1;
            this.deferVisible = true;
        },
        openXfModal(data){
            this.xfForm = Object.assign({},data);
            this.xfDetailShow = true;
        },
        confirmXfOrder() {
            let xfBoxList = [...this.xfBoxList];
            let condition = {
                OT_BOX_XF_MASTER: '',
                OT_BOX_XF_DETAIL: []
            };
            let OT_BOX_XR_DETAIL = {};
            let flag = true;
            condition.OT_BOX_XF_MASTER = [{
                "VOUCHER_ID": xfBoxList[0].MASTER_ID,
                "CURRENCY_ID": xfBoxList[0].CURRENCY_ID,
                "MEMO": '',
            }];
            xfBoxList.forEach(item => {
                if (!item.BOX_CODE || !item.TAKE_DATE) {
                    flag = false;
                }
                if (item.BOX_CODE && item.TAKE_DATE) {
                    OT_BOX_XR_DETAIL = {
                        "SEND_DRIVER": item.SEND_DRIVER,
                        "SEND_PERSON": item.SEND_PERSON,
                        "SEND_TRUCK": item.SEND_TRUCK,
                        BOX_CODE: item.BOX_CODE,
                        PARENT_FLOW_ID: item.PARENT_FLOW_ID,
                        "MEMO": '',
                        TAKE_DATE: this.$moment(item.TAKE_DATE).format('YYYY-MM-DD'),
                        GUID_CODES: item.GUID_CODES ? item.GUID_CODES.map(val => val.GUID_CODE).join(','):'',
                    }
                    condition.OT_BOX_XF_DETAIL.push(OT_BOX_XR_DETAIL)
                }
            })
            if (this.loading && flag) {
                this.loading = false;
                this.$h5Api({
                    type: '4027',
                    data: [condition],
                }).then(({data}) => {
                    this.xfShow = false;
                    this.BOX_CODE_LIST = []
                    this.$message.info(this.$t('confirmationSuccessful'));
                    this.getOrderDetail(this.$route.query.MASTER_ID);
                }).finally(() => {
                    this.loading = true;
                })
            }
        },
        confirmDelay() {
            this.$refs.deferForm.validate(val => {
                if (val) {
                    let condition = {
                        MASTER_ID: this.deferForm.MASTER_ID,
                        FLOW_ID: this.deferForm.FLOW_ID,
                        DELAY_QTY: this.deferForm.DELAY_QTY || 1,
                        DELAY_END_DATE: this.deferForm.DELAY_END_DATE || '',
                        DELAY_DESC: this.deferForm.DELAY_DESC || '',
                        OPER_TYPE: 0
                    }
                    if(this.loading){
                        this.loading = false;
                        this.$h5Api({
                            type: '4020',
                            data: [condition],
                        }).then(({data}) => {
                            this.$message.info("申请成功！");
                            this.getOrderDetail(this.orderForm.MASTER_ID);
                            this.deferVisible = false;
                        }).finally(() =>{
                            this.loading = true;
                        })
                    }
                }
            })
        },
    },
    created() {
    }
};

export default xfScript
